import { Vector } from '@moleculeone/types';
import { V4 } from '@moleculeone/utils';

export function txt(p: any) {
  return `${p[0].toFixed(2)} ${p[1].toFixed(2)}`;
}

export function wedgeTxt(wedge: any) {
  return `${txt(wedge.startLeft)} 
    ${txt(wedge.startRight)} 
    ${txt(wedge.endRight)} 
    ${txt(wedge.endLeft)}`;
}

export function wedgePoints(start: Vector, end: Vector, startWidth: number, endWidth: number) {
  const parallelDir = V4.normal(V4.sub(end, start));
  const perpendicularDir = V4.rotZ(parallelDir, Math.PI * 0.5);
  return {
    startLeft: V4.move(start, perpendicularDir, startWidth / 2.0),
    startRight: V4.move(start, perpendicularDir, -startWidth / 2.0),
    endLeft: V4.move(end, perpendicularDir, endWidth / 2.0),
    endRight: V4.move(end, perpendicularDir, -endWidth / 2.0),
  };
}
